import { Link as RouterLink } from 'react-router';

import { routes } from '@/assets/constants/routes-no.ts';
import { SEO } from '@/lib/seo.tsx';
import useBrainSession from '@/services/BrainSession/useBrainSession.ts';
import { Button } from '@/ui/button-2.tsx';

import RrsHandler from '../../components/RrsHandler/index.ts';
import Section from '../../components/Section/index.ts';
import Disclaimer from '../Common/Disclaimer.tsx';

import HeaderSection from './_components/HeaderSection/HeaderSection.tsx';
import { RRS_MY_DEBT } from './RRS.ts';

const linkClassName =
  'typography-v1-legacy-p3 font-normal text-[#18A0FB]! no-underline hover:underline';

const articleRowClassName = 'mx-auto flex w-full max-w-[900px]! flex-col flex-wrap sm:flex-row';

const footerButtonClassName = 'max-w-[550px] self-center sm:min-w-[330px]';

const MyDebt: React.FC = () => {
  const { toggleChat } = useBrainSession();

  const openFooterChat = () => {
    toggleChat({
      goal: 'debt_check',
      step: 'refin_present_terms_auto_new',
    });
  };

  return (
    <>
      <SEO
        title="Min gjeld: full oversikt over usikret gjeld"
        description="Hent all forbruksgjeld fra Gjeldsregisteret med BankID. Se renter, restgjeld og hva du kan spare på å refinansiere."
        path={routes.MY_DEBT}
      />
      <RrsHandler {...RRS_MY_DEBT} />
      <HeaderSection variant="a1" />
      <Section background="paper" last>
        <div className={articleRowClassName}>
          <div className="w-full sm:w-1/2 sm:pr-6">
            <h3 className="mb-4 typography-v1-legacy-subtitle1Bold">Hva er min gjeld?</h3>
            <p className="mb-8 typography-v1-legacy-p3 sm:mb-14">
              Min gjeld er en tjeneste levert av Scoopr som lar deg sjekke hvor mye du har i gjeld
              OG hva du kan spare på å bytte avtale. Det gjør du kun med et par tastetrykk – enklere
              blir det ikke!
              <br />
              <br />
              Du fyller bare ut opplysningene dine og logger inn med BankID, så fikser vi resten.
            </p>

            <h3 className="mb-4 typography-v1-legacy-subtitle1Bold">
              Få oversikt over kredittgjeld
            </h3>
            <p className="mb-8 typography-v1-legacy-p3 sm:mb-14">
              <RouterLink className={linkClassName} to={routes.DEBT_REGISTER}>
                Gjeldsregisteret{' '}
              </RouterLink>
              viser ikke bare hvor mye penger du har lånt, men også kreditt du ikke har brukt. En
              ekstra fordel med at du får se all gjelden din samlet på ett sted, er derfor at du
              kanskje oppdager noe som har gått i glemmeboken – som et{' '}
              <RouterLink className={linkClassName} to={routes.CREDIT_CARD_LOAN}>
                kredittkort
              </RouterLink>{' '}
              du egentlig ikke bruker. Da er det lurt å kvitte seg med dette.
              <br />
              <br /> En annen ting du bør tenke på er å senke kredittgrensen hvis du har flere kort
              med høy kreditt, men samtidig ønsker å beholde dem. Det er nemlig maksgrensen på
              kortet som vises som den totale gjelden du har, noe som kan telle negativt når bankene
              vurderer betalingsevnen din når du søker lån.
            </p>
          </div>

          <div className="w-full sm:w-1/2 sm:pl-6">
            <h3 className="mb-4 typography-v1-legacy-subtitle1Bold">Hvor kan jeg se min gjeld?</h3>
            <p className="mb-8 typography-v1-legacy-p3 sm:mb-14">
              Du trenger ikke lure på hva gjelden din er eller å sette deg ned med ulike dokumenter
              for å regne på totalen. Du ser enkelt hva du har i gjeld ved å logge inn på Min gjeld,
              som igjen henter informasjon fra Gjeldsregisteret. Her får du hele oversikten over all
              den usikrede gjelden du har, altså forbrukslån, kredittkort og handlekontoer.
            </p>

            <h3 className="mb-4 typography-v1-legacy-subtitle1Bold">
              Min gjeld skal etter hvert inkludere boliglån
            </h3>
            <p className="mb-8 typography-v1-legacy-p3 sm:mb-14">
              Med en god oversikt over gjelden din beholder du kontrollen over økonomien din.
              Kanskje du til og med ser at du kunne betalt ned mer enn det du gjør i dag, eller
              oppdager at gjelden er større eller mindre enn du trodde? Når du vet bedre kan du
              gjøre bedre – som for eksempel å nedbetale forbrukslån og utestående kredittgjeld så
              fort som mulig.
              <br />
              <br />
              Etter hvert vil gjeldsregisteret inkludere boliglån. Da får du oversikt over ALL
              gjeld, og ikke bare. Det vil vi i Scoopr følge med på, og selvfølgelig utvikle Min
              gjeld slik at du også kan se om det er penger å spare på å flytte boliglånet ditt. Vi
              er ikke der riktig ennå, men oppdaterer så fort det skjer.
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center">
          <h3 className="mx-auto mt-14 mb-8 max-w-[900px]! text-center typography-v1-legacy-subtitle1Bold sm:mt-[136px] sm:mb-8">
            Scoopr hjelper deg med det også!
          </h3>
          <Button color="yellow" className={footerButtonClassName} onClick={openFooterChat}>
            Sjekke om du kan få en bedre avtale
          </Button>
          <Disclaimer />
        </div>
      </Section>
    </>
  );
};

export default MyDebt;
